import { IconName, MaybeElement } from "@blueprintjs/core";
import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";
import { BlockStylesConfig, blockStylesInput } from "../common/BlockStylesConfig";


@Form({title: "Dialog Box config"})
export class DialogConfig {

	@Input({type: InputType.TEXT, title: "Title"})
	public title?: string;

	@Input({type: InputType.UNIT, title: "Width"})
	public width?: string;

	@Input({type: InputType.UNIT, title: "Height"})
	public height?: string;

	@Input({type: InputType.UNIT, title: "Min Height"})
	public minHeight?: string;

	@Input({type: InputType.TEXT, title: "Icon Name"})
	public icon?: IconName | MaybeElement;

	@Input({type: InputType.CHECKBOX, title: "Fixed position"})
	public fullscreen: boolean;

	@Input({type: InputType.CHECKBOX, title: "Is close button shown?"})
	public isCloseButtonShown: boolean;

	@Input({type: InputType.CHECKBOX, title: "Use Portal"})
	public usePortal?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Auto focus"})
	public autoFocus?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Can escape key close?"})
	public canEscapeKeyClose?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Can outside click close?"})
	public canOutsideClickClose?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enforce focus?"})
	public enforceFocus?: boolean;

	@Input({type: blockStylesInput, title: "Styles"})
	public styles?: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Header Styles"})
	public headerStyles?: BlockStylesConfig = {};
}



// WEBPACK FOOTER //
// ./src/common/views/dialog/DialogConfig.ts